import React from 'react';
import PropTypes from 'prop-types';

import './Center.css';

class Center extends React.Component {

  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
  }

  render() {
    const { className, children } = this.props;
    return (
      <div name="Center" className={className}>{children}</div>
    );
  }

}

export default Center;
